import React, { useEffect, useState, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { CountryStatusCssClasses } from "../CountriesUIHelpers";
import * as actions from "../../../_redux/countries/countriesActions";
import { useCountriesUIContext } from "../CountriesUIContext";

const selectedCountries = (entities, ids) => {
  const _countries = [];
  ids.forEach((id) => {
    const country = entities.find((el) => el.id === id);
    if (country) {
      _countries.push(country);
    }
  });
  return _countries;
};

export function CountriesUpdateStatusDialog({ show, onHide }) {
  // Countries UI Context
  const countriesUIContext = useCountriesUIContext();
  const countriesUIProps = useMemo(() => {
    return {
      ids: countriesUIContext.ids,
      setIds: countriesUIContext.setIds,
      queryParams: countriesUIContext.queryParams,
    };
  }, [countriesUIContext]);

  // Countries Redux state
  const { countries, isLoading } = useSelector(
    (state) => ({
      countries: selectedCountries(state.countries.entities, countriesUIProps.ids),
      isLoading: state.countries.actionsLoading,
    }),
    shallowEqual
  );

  // if there weren't selected countries we should close modal
  useEffect(() => {
    if (!countriesUIProps.ids || countriesUIProps.ids.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countriesUIProps.ids]);

  const [status, setStatus] = useState("active");

  const dispatch = useDispatch();
  const updateStatus = () => {
    // server request for updating country by ids
    dispatch(actions.updateCountriesStatus(countriesUIProps.ids, status)).then(
      () => {
        // refresh list after update
        dispatch(actions.fetchCountries(countriesUIProps.queryParams)).then(
          () => {
            // clear selections list
            countriesUIProps.setIds([]);
            // closing modal
            onHide();
          }
        );
      }
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      aria-labelledby="country-status-modal-title"
    >
      <Modal.Header closeButton className="py-4 px-6">
        <Modal.Title id="country-status-modal-title" className="font-weight-bolder text-dark">
          Update Status for Selected Countries
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-4 px-6">
        <div className="alert alert-custom alert-light-primary fade show mb-4 py-3 px-4 d-flex align-items-center" role="alert">
          <div className="alert-icon mr-3">
            <i className="fa fa-info-circle text-primary font-size-h5"></i>
          </div>
          <div className="alert-text font-size-sm text-dark font-weight-bold">
            Updating status for <span className="text-primary font-size-lg font-weight-bolder">{countriesUIProps.ids.length}</span> selected countries.
          </div>
        </div>

        <div className="form-group mb-2">
          <label className="font-weight-bold text-dark font-size-sm mb-2">
            Change Status To
          </label>
          <select
            className="form-control"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
      </Modal.Body>
      <Modal.Footer className="py-3 px-6">
        <button
          type="button"
          onClick={onHide}
          className="btn btn-light font-weight-bold"
          disabled={isLoading}
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={updateStatus}
          className="btn btn-primary font-weight-bold"
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <i className="fa fa-circle-notch fa-spin mr-1"></i> Updating...
            </>
          ) : (
            "Update Status"
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
